import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { Injectable, Provider } from '@angular/core';
import { CustomMatDatepickerIntl } from './custom-mat-datepicker-intl';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    override parse(value: string): Date | null {
        if (value == null || typeof value !== 'string') {
            return null;
        }

        const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
        if (match) {
            const year = Number.parseInt(match[1], 10);
            const month = Number.parseInt(match[2], 10) - 1;
            const day = Number.parseInt(match[3], 10);
            return new Date(year, month, day);
        }

        // Return invalid Date for partial inputs to allow editing without resetting
        return value as unknown as Date;
    }

    override format(date: Date): string {
        const year: number = date.getFullYear();
        const month: string | number = this._to2digit(date.getMonth() + 1);
        const day: string | number = this._to2digit(date.getDate());
        return `${year}-${month}-${day}`;
    }

    private _to2digit(n: number): string {
        return n < 10 ? '0' + n : '' + n;
    }
}

export const DATE_PICKER_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthLabel: 'MMMM',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export function provideCustomDateAdapter(): Provider[] {
    return [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: DATE_PICKER_FORMATS },
        { provide: MatDatepickerIntl, useClass: CustomMatDatepickerIntl },
    ];
}
